import TextBlockTriplet from './TextBlockTriplet';

export default TextBlockTriplet;
